/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Program_NameInputs */



/**
* | output |
* | --- |
* | "Program Name" |
*
* @param {Subtitle_Export_Program_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_program_name = /** @type {((inputs?: Subtitle_Export_Program_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Program_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom du programme")
	if (locale === "de") return /** @type {LocalizedString} */ ("Programmname")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome del programma")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Название программы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre del programa")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("程序名称")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プログラム名")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्यक्रम का नाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nome do programa")
	return /** @type {LocalizedString} */ ("Program Name")
});